import React from 'react';
import PropTypes from 'prop-types';

import Menu, { MenuItem } from 'WeployDesignLanguage/Menu';
import { OverflowMenuButton } from 'LegacyWeployDesignLanguage/icons';
import Fade from 'WeployDesignLanguage/transitions/Fade';

const OverflowMenu = ({ children }) => {
  const [menuAnchorElement, setMenuAnchorElement] = React.useState(null);
  const open = Boolean(menuAnchorElement);

  OverflowMenu.close = () => setMenuAnchorElement(null);

  const handleMenuClick = event => (
    setMenuAnchorElement(event.currentTarget)
  );

  const handleMenuClose = () => (
    setMenuAnchorElement(null)
  );

  return (
    <>
      <Menu
        id="fade-menu"
        anchorEl={menuAnchorElement}
        keepMounted
        open={open}
        onClose={handleMenuClose}
        TransitionComponent={Fade}
      >
        {children}
      </Menu>
      <OverflowMenuButton onClick={handleMenuClick} />
    </>
  );
};

OverflowMenu.MenuItem = MenuItem;

OverflowMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default OverflowMenu;

